var render, staticRenderFns
import script from "./CountryFlag.vue?vue&type=script&lang=js&"
export * from "./CountryFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/core-product/common/vue2/patsnap-biz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4017408e')) {
      api.createRecord('4017408e', component.options)
    } else {
      api.reload('4017408e', component.options)
    }
    
  }
}
component.options.__file = "src/CountryFlag.vue"
export default component.exports